import { Validators } from '@angular/forms';
import { errorValueValidator } from '@shared/validators/error-value-validator';
import { ValidationPair } from '@app/modules/service-data/types/service-data.types';
import { crossFieldValidator } from '@shared/validators/cross-field-validator';

export const carrierSampleValidationSet: ValidationPair = {
  children: {
    shared: {
      children: {
        doctorInformation: {
          children: {
            doctorId: {
              validators: [Validators.required],
            },
          },
        },
        patientHistory: {
          children: {
            stemCellTherapy: {
              children: {
                hasReceived: {
                  validators: [Validators.required, errorValueValidator(true)],
                },
              },
            },
            transplantSurgery: {
              children: {
                hasReceived: {
                  validators: [Validators.required, errorValueValidator(true)],
                },
              },
            },
            bloodTransfusion: {
              children: {
                hasReceived: {
                  validators: [Validators.required],
                },
                isRelevant: {
                  validators: [errorValueValidator(true)],
                },
              },
            },
          },
        },
      },
      validators: [
        crossFieldValidator(
          'patientHistory.bloodTransfusion.isRelevant',
          'patientHistory.bloodTransfusion.hasReceived',
          true
        ),
      ],
    },
  },
};
